/* (c) Copyright Frontify Ltd., all rights reserved. */

export const UNDERLINE_PLUGIN = 'underline-plugin';
